import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardNoteConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:note';

  override async prepareBlock(
    note: BlockSnapshot
  ): Promise<PreparedEdgelessBlock | null> {
    const oldId = note.id;

    delete note.props.index;
    if (!note.props.xywh) {
      console.error(`Note block(id: ${oldId}) does not have xywh property`);
      return null;
    }

    const prepared = await this.prepareSnapshotPaste(
      note,
      this.std.store,
      this.std.store.root!.id
    );
    if (!prepared) console.error(`Failed to paste note block(id: ${oldId})`);
    return prepared;
  }
}
